import React from 'react'
import styled from 'styled-components'

/**
 * 選択肢の各行
 */
const ItemLine: React.FC<ItemLineProps> = (props) => {
  return (
    <React.Fragment>
      {!props.isHide && (
        <StyledItemLine
          showLineBorder={props.showLineBorder}
          lineOffset={props.lineOffset}
          width={props.width}
        >
          <ItemLineContent
            onClick={props.isHide ? undefined : props.onClick}
            variableHeight={props.variableHeight}
            paddingUnnecessary={props.paddingUnnecessary}
          >
            {props.children}
          </ItemLineContent>
        </StyledItemLine>
      )}
    </React.Fragment>
  )
}

export type ItemLineProps = {
  children: React.ReactNode
  showLineBorder?: boolean
  lineOffset?: string
  variableHeight?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  isHide?: boolean
  width?: string
  paddingUnnecessary?: boolean
}

export const StyledItemLine = styled.div<{
  showLineBorder?: boolean
  lineOffset?: string
  width?: string
}>`
  ${(props): string =>
    props.width
      ? `
      width:${props.width};
      background: var(--color-content-background);
      border-top: 1px solid var(--color-border);
      border-bottom: 1px solid var(--color-border);
      `
      : ''}

  ${(props): string =>
    props.showLineBorder
      ? `
      &&:after {
        position: relative;
        left: ${props.lineOffset ? props.lineOffset : '0'};
        display: block;
        width: calc(100% - ${props.lineOffset ? props.lineOffset : '0'});
        border-bottom: 1px solid var(--color-border);
        content: '';
      }
      &&:last-child:after {
        border-bottom: none;
      }
      `
      : ''}
`

const ItemLineContent = styled.div<{
  variableHeight?: boolean
  paddingUnnecessary?: boolean
}>`
  display: flex;
  align-items: center;
  ${(props): string => (props.paddingUnnecessary ? '' : 'padding-block: 8px;')}
  ${(props): string => (props.variableHeight ? '' : 'height: auto;')}
`

export default ItemLine
